function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/view/observer/domeventdata
 */
import { extend } from 'lodash-es';
/**
 * Information about a DOM event in context of the {@link module:engine/view/document~Document}.
 * It wraps the native event, which usually should not be used as the wrapper contains
 * additional data (like key code for keyboard events).
 */

var DomEventData =
/*#__PURE__*/
function () {
  /**
   * @param {module:engine/view/view~View} view The instance of the view controller.
   * @param {Event} domEvent The DOM event.
   * @param {Object} [additionalData] Additional properties that the instance should contain.
   */
  function DomEventData(view, domEvent, additionalData) {
    _classCallCheck(this, DomEventData);

    /**
     * Instance of the view controller.
     *
     * @readonly
     * @member {module:engine/view/view~View} module:engine/view/observer/observer~Observer.DomEvent#view
     */
    this.view = view;
    /**
     * The instance of the document.
     *
     * @readonly
     * @member {module:engine/view/document~Document} module:engine/view/observer/observer~Observer.DomEvent#document
     */

    this.document = view.document;
    /**
     * The DOM event.
     *
     * @readonly
     * @member {Event} module:engine/view/observer/observer~Observer.DomEvent#domEvent
     */

    this.domEvent = domEvent;
    /**
     * The DOM target.
     *
     * @readonly
     * @member {HTMLElement} module:engine/view/observer/observer~Observer.DomEvent#target
     */

    this.domTarget = domEvent.target;
    extend(this, additionalData);
  }
  /**
   * The tree view element representing the target.
   *
   * @readonly
   * @type module:engine/view/element~Element
   */


  _createClass(DomEventData, [{
    key: "preventDefault",

    /**
     * Prevents the native's event default action.
     */
    value: function preventDefault() {
      this.domEvent.preventDefault();
    }
    /**
     * Stops native event propagation.
     */

  }, {
    key: "stopPropagation",
    value: function stopPropagation() {
      this.domEvent.stopPropagation();
    }
  }, {
    key: "target",
    get: function get() {
      return this.view.domConverter.mapDomToView(this.domTarget);
    }
  }]);

  return DomEventData;
}();

export { DomEventData as default };